<script lang="ts">
  import { params, redirect } from '@sveltech/routify';

  let id = $params['id'];

  let firebase = window.firebase;

  let data: Need_v1;

  async function getNeed() {
    await firebase
      .firestore()
      .collection('needs_v1')
      .doc(id)
      .get()
      .then((doc) => {
        data = doc.data() as Need_v1;
      });
  }

  getNeed().then(() => {
    _redirect();
  });

  function _redirect() {
    $redirect('../details');
  }
</script>
